export default __webpack_public_path__ + "static/media/info.b3a50221.svg";